import React from 'react';

import {GenericPaginatedListRTK} from 'app/components/general/lists/GenericPaginatedListRTK';
import {useGetInvitations} from 'app/user/api';
import {DEFAULT_PAGE_SIZE} from 'app/utils/constants';
import {gt} from 'app/utils/i18n';

import {InvitationItem} from './InvitationItem';

export const InvitationList = () => (
  <GenericPaginatedListRTK
    ItemComponent={InvitationItem}
    useQuery={useGetInvitations}
    noItemsMessage={() => gt('No invitations exist for this member')}
    paramsBuilder={({params}) => ({
      user_id: params.userid,
      page_size: DEFAULT_PAGE_SIZE,
    })}
  />
);
